import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取前端路由
 * @param params
 */
export const getRouter = (params = {}) => {
  return request({
    url: env.ferryUrl + '/menu/tree',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 * 获取当前登陆用户信息
 */
export const getUserInfo = () => {
  return request({
    url: env.ferryUrl + '/user/info',
    method: 'get'
  })
}

/**
 *  退出登陆
 */
export const logout = () => {
  return request({
    url: env.loginUrl + '/v2/remove',
    method: 'DELETE'
  })
}

/**
 * 列表
 * @param current
 * @param size
 * @param params
 */
export const list = (current, size, params = {}) => {
  return request({
    url: env.ferryUrl + '/user/page',
    method: 'get',
    params: {
      current,
      size,
      ...params
    }
  })
}

/**
 * 保存
 * @param data
 */
export const save = (data) => {
  return request({
    url: env.ferryUrl + '/user',
    method: 'post',
    data
  })
}

/**
 * 编辑
 * @param data
 */
export const edit = (data) => {
  return request({
    url: env.ferryUrl + '/user/edit',
    method: 'PUT',
    data
  })
}

/**
 * 编辑mimi
 * @param data
 */
export const editPassword = (data) => {
  return request({
    url: env.ferryUrl + '/user/updatePassword',
    method: 'POST',
    data
  })
}

// 判断当前token是否可用
export const checkToken = (data) => {
  return request({
    url: '/custom-auth/token-with-phone',
    method: 'GET'
  })
}
/**
 * 获取接送机订单
 * @param data
 */
export const getPickupList = (data) => {
  return request({
    url: env.ferryUrl + '/user/info/ferry-order/page',
    method: 'POST',
    data
  })
}
